import React from 'react';
import { Space } from '../app/entities/space';
import { Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { context } from '../app/context';

interface Props {
  space: Space;
}

export const MembersOnlyRoute: React.FC<Props> = observer(({ space }) => {
  const currentMember = context.member;
  if (currentMember?.role === 'guest') {
    return <Navigate to={`/space/${space._id}`} replace />;
  }
  return <Outlet />;
});
